import React, { useState } from "react";
import { Search, ShieldCheck, Sparkles } from "lucide-react";
import { toast } from "sonner";

/**
 * Vehicle Intelligence Platform stub — v1 visual only.
 * When the license-plate API is wired, POST to the shared backend and render results.
 */
export default function VehicleIntelligenceBanner() {
  const [plate, setPlate] = useState("");

  const submit = (e) => {
    e.preventDefault();
    if (!plate.trim()) return;
    toast.info("Vehicle Intelligence coming soon — we'll notify you when reports launch.");
  };

  return (
    <section id="vehicle-intel" className="max-w-7xl mx-auto px-4 md:px-8 py-10">
      <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-slate-900 via-slate-900 to-[#0F70A8] p-8 md:p-14 text-white">
        <div className="absolute -top-16 -right-10 w-72 h-72 rounded-full bg-[color:var(--brand-orange)]/25 blur-3xl" />
        <div className="absolute bottom-0 left-1/3 w-64 h-64 rounded-full bg-[color:var(--brand-blue)]/20 blur-3xl" />

        <div className="relative max-w-3xl">
          <div className="inline-flex items-center gap-2 rounded-full bg-white/10 backdrop-blur-md px-3 py-1 border border-white/15">
            <Sparkles className="w-3.5 h-3.5 text-[color:var(--brand-orange)]" />
            <span className="text-[10px] md:text-xs font-bold uppercase tracking-[0.24em]">Vehicle Intelligence Platform</span>
          </div>
          <h2 className="mt-4 font-display text-3xl md:text-5xl font-black leading-tight tracking-tight">
            Instant <span className="text-[color:var(--brand-orange)]">Vehicle Report</span>
          </h2>
          <p className="mt-3 text-white/80 max-w-xl leading-relaxed text-sm md:text-base">
            Enter a license plate to unlock comprehensive vehicle history, compliance status and risk assessment.
          </p>

          <form onSubmit={submit} className="mt-6 flex flex-col sm:flex-row items-stretch gap-2 max-w-lg">
            <div className="relative flex-1">
              <Search className="w-4 h-4 text-slate-400 absolute left-4 top-1/2 -translate-y-1/2" />
              <input
                data-testid="vehicle-intel-plate"
                value={plate}
                onChange={(e) => setPlate(e.target.value.toUpperCase())}
                placeholder="e.g. ABC123"
                className="w-full pl-11 pr-4 py-3 rounded-full bg-white text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-[color:var(--brand-orange)] tracking-widest font-semibold"
                maxLength={8}
              />
            </div>
            <button
              type="submit"
              data-testid="vehicle-intel-submit"
              className="rounded-full bg-[color:var(--brand-orange)] hover:bg-[color:var(--brand-orange-hover)] text-white font-bold px-6 py-3 transition-colors"
            >
              Search Now
            </button>
          </form>

          <ul className="mt-6 flex flex-wrap gap-x-6 gap-y-2 text-xs md:text-sm text-white/80">
            <li className="inline-flex items-center gap-1.5"><ShieldCheck className="w-4 h-4 text-emerald-400" /> Live NZ data</li>
            <li className="inline-flex items-center gap-1.5"><ShieldCheck className="w-4 h-4 text-emerald-400" /> PPSR security check</li>
            <li className="inline-flex items-center gap-1.5"><ShieldCheck className="w-4 h-4 text-emerald-400" /> WOF & licence status</li>
            <li className="inline-flex items-center gap-1.5"><ShieldCheck className="w-4 h-4 text-emerald-400" /> Instant results</li>
          </ul>
        </div>
      </div>
    </section>
  );
}
